import React, { useState } from "react";
import ContentLayout from "../../components/ContentLayout/ContentLayout";
import SpecialTokensForm from "../../components/SpecialTokensForm";
import boltCircle from "../../assets/img/boltCircle.svg";
import { submitSpecialToken } from "../../services/specialToken";
import { useMutation } from "react-query";
import { AxiosError } from "axios";
import { toast } from "react-toastify";
import SpecialTokenGeneratedModal from "../../components/Modals/SpecialTokenModal/SpecialTokenModal";
import { SpecialTokenResponse } from "../../services/specialToken";

const SelfServiceAdminSpecialTokens = () => {

  const [responseData, setResponseData] = useState<SpecialTokenResponse | null>(null);
  const [showModal, setShowModal] = useState(false);

  const { mutate, isLoading } = useMutation(submitSpecialToken, {
    onSuccess: ({ data }) => {
      if (data.keyChangeRequired === false || data.numTokens === 0) {
        toast.info(data.description || "This meter does not require an updated key");
        return;
      }

      setResponseData(data);
      setShowModal(true);
    },
    onError: (error: AxiosError) => {
      const errorMessage =
        //@ts-ignore
        error?.response?.data?.message || error?.response?.data?.errors?.[0] || "Unknown error occurred";
      toast.error(errorMessage);
    },
  });

  const onSubmit = (data: { meterNumber: string; tokenType: string | number; reason: string }) => {
    if (!data.meterNumber.trim() || !data.tokenType || !data.reason.trim()) {
      toast.error("Meter number, token type, and reason are required");
      return;
    }

    setResponseData(null);
    mutate({
      meterId: data.meterNumber.trim(),
      subclass: Number(data.tokenType),
      messageId: data.reason.trim(),
      supp: 0,
    });
  };

  return (
    <ContentLayout headerName="Special Tokens" iconName={boltCircle}>
      <div className="w-full px-6  py-4  flex flex-col gap-4 !overflow-hidden ">
         
        <div className="flex flex-col gap-12">
           
          <SpecialTokensForm onSubmit = {onSubmit} isLoading={isLoading}/>
        </div>

        
      </div>
      <SpecialTokenGeneratedModal
        showModal={showModal}
        setShowModal={setShowModal}
        tokenData={responseData}
      />
    </ContentLayout>
  );
};

export default SelfServiceAdminSpecialTokens;
